const MODULE_PLM = "productLifeCycleManagement";
const MODULE_LOGISTIC_OP = "logisticOperator";
const SUPPLIERS_PANEL = "suppliersPanel";

let ALL_MODULES = {MODULE_PLM, MODULE_LOGISTIC_OP, SUPPLIERS_PANEL};

const AUTOCONF_LOGISTIC = "logistic";
const AUTOCONF_PLM = "plm";
const AUTOCONF_ALL = "all";

const AUTOCONF_MODULES = {
    "logistic": [MODULE_LOGISTIC_OP],
    "plm": [MODULE_PLM],
    "all": ALL_MODULES,
    "suppliers": [SUPPLIERS_PANEL]
}

const AUTOCONF_TEMPLATES = {
    "logistic": "default",
    "plm": "default",
    "all": "default",
    "suppliers": "supplier"
}

export {MODULE_PLM, MODULE_LOGISTIC_OP, ALL_MODULES, AUTOCONF_MODULES, AUTOCONF_TEMPLATES, AUTOCONF_LOGISTIC, AUTOCONF_PLM, AUTOCONF_ALL, SUPPLIERS_PANEL}
